import styled from 'styled-components';

export const Mask = styled.div`
	position: absolute;
	background: rgba(0, 0, 0, 0.5);
	pointer-events: none;
`;
